import { jsxs as v, jsx as r } from "react/jsx-runtime";
import { E as p, S as d } from "./icons.types-0722eef5.js";
function m({ title: n, titleId: o, size: a, width: s, height: h, extended: l = !1, ...i }) {
  const c = l ? p : d, t = a ? c[a] : s || c[l ? "s" : "l"], e = a ? c[a] : h || c[l ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: t,
      height: e,
      "aria-labelledby": o,
      ...i,
      children: [
        n ? /* @__PURE__ */ r("title", { id: o, children: n }) : null,
        /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M7.077 28.666a2.326 2.326 0 0 1-1.71-.7 2.326 2.326 0 0 1-.7-1.71V8.41c0-.673.233-1.243.7-1.71a2.327 2.327 0 0 1 1.71-.7h1.846V4.205c0-.29.098-.534.295-.73a.995.995 0 0 1 .732-.296c.292 0 .535.099.73.295.196.197.294.44.294.731V6h10.103V4.18c0-.284.096-.521.287-.713a.968.968 0 0 1 .713-.288c.284 0 .521.096.712.288.192.192.288.43.288.712V6h1.846c.673 0 1.243.234 1.71.7.467.468.7 1.038.7 1.711v6.795c0 .283-.096.52-.287.713a.969.969 0 0 1-.713.287.967.967 0 0 1-.713-.287.968.968 0 0 1-.287-.713v-1.462H6.666v12.513c0 .103.043.197.129.282.085.086.18.129.282.129h8.115c.284 0 .521.095.713.287.191.192.287.43.287.713 0 .284-.096.52-.287.712a.968.968 0 0 1-.713.287H7.077Zm18.256 3.129c-1.36 0-2.575-.378-3.647-1.132a6.548 6.548 0 0 1-2.343-2.917.573.573 0 0 1 .045-.588.583.583 0 0 1 .515-.286c.256 0 .486.075.69.225.205.15.367.345.489.582a4.762 4.762 0 0 0 1.737 1.835c.75.46 1.588.691 2.514.691 1.346 0 2.494-.475 3.445-1.427.951-.95 1.427-2.1 1.427-3.445 0-1.345-.476-2.494-1.427-3.445-.951-.951-2.1-1.427-3.445-1.427-.73 0-1.42.158-2.07.472a5.496 5.496 0 0 0-1.697 1.272H23a.772.772 0 0 1 .795.794.773.773 0 0 1-.795.796h-2.923c-.342 0-.628-.116-.859-.347a1.166 1.166 0 0 1-.346-.858v-2.923a.771.771 0 0 1 .794-.795.772.772 0 0 1 .795.795v1.387a7.247 7.247 0 0 1 2.19-1.582c.843-.4 1.737-.6 2.682-.6 1.788 0 3.312.63 4.572 1.89 1.26 1.26 1.89 2.784 1.89 4.571 0 1.788-.63 3.312-1.89 4.572-1.26 1.26-2.784 1.89-4.572 1.89ZM6.666 11.744h18.667V8.41a.392.392 0 0 0-.128-.282.392.392 0 0 0-.282-.128H7.077a.392.392 0 0 0-.282.128.392.392 0 0 0-.129.282v3.334Z"
          }
        )
      ]
    }
  );
}
export {
  m as CalendarRepeat
};
